import React, { Component } from 'react';
import moment from 'moment';

class PayoutTableComponent extends Component {
    render() {
        return (
            <table className="w-full table-bordered">
                <thead className="text-left text-primary border-bottom whitespace-nowrap">
                    <tr>
                        <th scope="col" className="p-3 font-medium">
                            Time
                        </th>
                        <th scope="col" className="p-3 font-medium text-center">
                            Amount
                        </th>
                        <th scope="col" className="p-3 font-medium text-end">
                            Status
                        </th>
                    </tr>
                </thead>
                <tbody className="break-word">
                    {this.props.CustomerFinancialReportsData &&
                    this.props.CustomerFinancialReportsData.length ? (
                        <>
                            {this.props.CustomerFinancialReportsData.map((value, index) => {
                                return (
                                    <tr key={index} className="border-bottom whitespace-nowrap">
                                        <td className="p-3 table-ellipse">
                                            {moment(value.createdDate).format(
                                                'MMM DD, YYYY hh:mm A'
                                            )}
                                        </td>
                                        <td className="p-3 text-center table-ellipse">
                                            {value?.amount}
                                        </td>
                                        <td className="p-3 table-ellipse text-end">
                                            {value?.status}
                                        </td>
                                    </tr>
                                );
                            })}
                        </>
                    ) : (
                        <tr>
                            <td colSpan="3" className="p-3 text-center text-white">
                                No data found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
}

export default PayoutTableComponent;
